import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { styles } from './styles.js';

const ApplicationButton = ({ classes, buttonProps, label, showIcon }) => (
  <LoadingButton
    variant="contained"
    color="primary"
    size="large"
    className={classes.root}
    {...buttonProps}
  >
    {label}
    {showIcon && <ArrowForwardIcon />}
  </LoadingButton>
);

ApplicationButton.defaultProps = {
  buttonProps: {},
  showIcon: false,
};

ApplicationButton.propTypes = {
  classes: PropTypes.object.isRequired,
  buttonProps: PropTypes.object,
  label: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
};

export default withStyles(styles)(ApplicationButton);
